import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import { dataFormatter } from "../../constant/condition";
import config from "../../config/Config";
import { Helmet } from "react-helmet";
import Loader from "./Loader";
import NotFound from "./NotFound";
import "../Styles/Home.css";
import ListingHero from "./ListingHero";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { CardImageThumb } from "./CardImageThumb";

export default function Blogpost() {
  const [isLoading, setIsLoading] = useState(true);
  const [configuration, setConfiguration] = useState([]);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [imageLightboxSrc, setImageLightboxSrc] = useState(null);
  const { tag, id, year, month } = useParams();

  function demo2() {
    let url;

    if (tag) {
      url = `${config.API_BLOG}getdata?tag=${tag}`;
    } else if (id) {
      url = `${config.API_BLOG}getdata?key=${id}`;
    } else if (year && month) {
      url = `${config.API_BLOG}getdata?year=${year}&month=${month}`;
    } else {
      url = `${config.API_BLOG}getdata`;
    }

    fetch(url)
      .then((result) => result.json())
      .then((res) => {
        const sortedData = res.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        );

        setAllData(sortedData);
        setData(sortedData.slice(0, 4));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }

  const toSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setConfiguration(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    setIsLoading(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
    demo2();
    fetchConfiguration();
  }, [id, tag, year, month]);

  useEffect(() => {
    setData(allData.slice(0, visibleCount));
  }, [visibleCount, allData]);

  const metaTitle = configuration[0]?.default_meta_title;
  const metaKeywords = configuration[0]?.default_meta_keywords;
  const metaDescription = configuration[0]?.default_meta_description;

  const siteLabel =
    configuration[0]?.default_meta_title?.split("|")[0]?.trim() || "iLearnings";

  const renderHTML = (rawHTML) => {
    return { __html: rawHTML };
  };

  const filteredData = data.filter((item) => item.post_status === 1);

  return (
    <div className="container-fluid page-shell mt-4 home-page">
      {isLoading ? (
        <div className="text-center mt-5 py-5">
          <Loader />
        </div>
      ) : filteredData.length === 0 ? (
        <div className="text-center py-5">
          <NotFound />
        </div>
      ) : (
        <>
          <Helmet>
            <title>Blogs</title>
            <meta name="title" content={metaTitle} />
            <meta name="keywords" content={metaKeywords} />
            <meta name="description" content={metaDescription} />
          </Helmet>

          <ListingHero
            siteLabel={siteLabel}
            description="Explore articles on web development, Magento, Laravel, databases, and more — written for developers who want clear, practical guidance."
            primaryStat={allData.length}
            primaryStatLabel="Blog posts"
            primaryCtaTo="/"
            primaryCtaLabel=""
            secondaryCtaTo="/tutorialseries"
            secondaryCtaLabel=""
          />

          <section className="home-section" aria-labelledby="blog-list-heading">
            <div className="home-section__head" data-aos="fade-up">
              <center
                style={{
                  fontSize: "38px",
                  fontFamily: "sofia",
                }}
              >
                <b>
                  All<b style={{ color: "#173a9b" }}> Blogs </b>
                </b>
                <hr
                  className="w-25 mx-auto"
                  style={{ transform: "translateY(-16px)" }}
                />
              </center>
            </div>

            <div
              className="row g-4 home-card-grid justify-content-center"
              style={{ transform: "translateY(-25px)" }}
            >
              {filteredData.map((item, index) => {
                const newTypeDate = dataFormatter(item.published_date);
                const limitedContent = (() => {
                  const parser = new DOMParser();
                  const plainText =
                    parser.parseFromString(item.post_content, "text/html").body
                      .textContent || "";
                  const letterOnlyText = plainText.replace(/[^a-zA-Z ]/g, "");
                  let letterCount = 0;
                  let limitedText = "";
                  for (let i = 0; i < letterOnlyText.length; i++) {
                    if (/[a-zA-Z]/.test(letterOnlyText[i])) {
                      letterCount++;
                    }
                    if (letterCount <= 200) {
                      limitedText += letterOnlyText[i];
                    } else {
                      break;
                    }
                  }
                  return limitedText + (letterCount > 200 ? "..." : "");
                })();

                return (
                  <div
                    className="col-12 col-xl-6 card_box"
                    key={item.post_id}
                    data-aos="fade-up"
                    data-aos-delay={Math.min(index * 70, 350)}
                  >
                    <article
                      className="card home-card h-100"
                      style={{ border: "1px solid rgba(23, 58, 155, 0.18)" }}
                    >
                      <div className="home-card__body">
                        <div className="home-card__thumb">
                          <CardImageThumb
                            src={item.post_banner_b64}
                            alt={item.post_title}
                            onOpen={setImageLightboxSrc}
                          />
                        </div>
                        <div className="home-card__content">
                          <Link
                            to={`/read/${toSlug(item.post_title)}`}
                            state={{ item }}
                            onClick={() => {
                              localStorage.setItem("post_id", item.post_id);
                            }}
                            className="home-card__title"
                          >
                            {item.post_title}
                          </Link>
                          <div
                            className="home-card__excerpt para_font_family"
                            dangerouslySetInnerHTML={renderHTML(limitedContent)}
                          />
                          <Link
                            to={`/read/${toSlug(item.post_title)}`}
                            state={{ item }}
                            onClick={() => {
                              localStorage.setItem("post_id", item.post_id);
                            }}
                            className="home-card__read"
                          >
                            Read more →
                          </Link>
                        </div>
                      </div>
                      <div className="home-card__tags">
                        <div className="tags-container">
                          {item.tags.map((t) => (
                            <Link
                              key={t.tag_id}
                              to={`/blog/tag/${toSlug(t.tag_name)}`}
                              state={{ item }}
                              className="tag-link"
                            >
                              <button type="button" className="tag-button">
                                {t.tag_name} ({t.posts_count})
                              </button>
                            </Link>
                          ))}
                        </div>
                        <div className="home-card__footer">
                          <div className="home-card__footer-inner para_font_family text-light">
                            <p style={{ textTransform: "capitalize" }}>
                              <b>By</b> {item.name}
                            </p>
                            <p>
                              <b>On</b> {newTypeDate}
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>

            {data.length < allData.length && (
              <div className="text-center mt-4 mb-3" data-aos="zoom-in">
                <button
                  type="button"
                  className="btn btn-dark px-5"
                  onClick={() => setVisibleCount(visibleCount + 6)}
                >
                  Load more
                </button>
              </div>
            )}
          </section>

          <div className="side1">
            <Sidebar />
          </div>

          {imageLightboxSrc ? (
            <Lightbox
              mainSrc={imageLightboxSrc}
              onCloseRequest={() => setImageLightboxSrc(null)}
            />
          ) : null}
        </>
      )}
    </div>
  );
}
